const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

(() => {
  const style = document.createElement('style');
  style.textContent = `
    form.klaviyo-form .klaviyo-emailinput:not(input) {
      width: 100% !important;
      min-height: 0 !important;
      height: auto !important;
      margin: 0 !important;
      padding: 0 !important;
      color: inherit !important;
      background: transparent !important;
      border: 0 !important;
      border-radius: 0 !important;
      outline: 0 !important;
      box-shadow: none !important;
    }

    form.klaviyo-form input.klaviyo-emailinput,
    form.klaviyo-form .klaviyo-emailinput input {
      display: block !important;
      width: 100% !important;
      min-height: 56px !important;
      height: 56px !important;
      margin: 0 !important;
      padding: 0 17px !important;
      color: #102a5e !important;
      background: #ffffff !important;
      border: 1px solid #cbd5e1 !important;
      border-radius: 12px !important;
      box-shadow: none !important;
      font-size: 16px !important;
      line-height: 1.25 !important;
    }

    form.klaviyo-form input.klaviyo-emailinput::placeholder,
    form.klaviyo-form .klaviyo-emailinput input::placeholder {
      color: #71809a !important;
      opacity: 1 !important;
    }

    form.klaviyo-form input.klaviyo-emailinput:focus,
    form.klaviyo-form .klaviyo-emailinput input:focus {
      border-color: #0d5bd7 !important;
      outline: 3px solid rgba(13, 91, 215, 0.22) !important;
      outline-offset: 2px !important;
    }
  `;
  document.head.append(style);

  const mobileStyle = document.createElement('style');
  mobileStyle.id = 'goalkit-klaviyo-mobile-bounds';
  mobileStyle.textContent = `
    @media screen and (max-width: 749px) {
      form.klaviyo-form {
        box-sizing: border-box !important;
        width: calc(100vw - 24px) !important;
        max-width: calc(100vw - 24px) !important;
        min-width: 0 !important;
        flex: 0 1 calc(100vw - 24px) !important;
        flex-basis: calc(100vw - 24px) !important;
      }

      form.klaviyo-form > :is(div, section, fieldset, [class], [style]) {
        box-sizing: border-box !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        flex: 0 1 100% !important;
        flex-basis: 100% !important;
      }

      form.klaviyo-form .klaviyo-form-richtext,
      form.klaviyo-form .klaviyo-form-richtext * {
        box-sizing: border-box !important;
        max-width: 100% !important;
        min-width: 0 !important;
        white-space: normal !important;
        overflow-wrap: break-word !important;
        word-break: normal !important;
      }

      form.klaviyo-form .klaviyo-emailinput:not(input),
      form.klaviyo-form input.klaviyo-emailinput,
      form.klaviyo-form .klaviyo-emailinput input,
      form.klaviyo-form .klaviyo-form-button {
        box-sizing: border-box !important;
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        flex: 0 1 100% !important;
        flex-basis: 100% !important;
      }
    }
  `;

  const installMobileStyle = () => {
    if (!document.getElementById(mobileStyle.id)) document.head.append(mobileStyle);
  };

  const observer = new MutationObserver(() => {
    if (document.querySelector('form.klaviyo-form')) {
      installMobileStyle();
      observer.disconnect();
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  if (document.querySelector('form.klaviyo-form')) installMobileStyle();
})();
